import React from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames';
import './style.scss';

const ProjectTitle = ({ title, responsive = true }) => (
    <div className={classnames('project-title-wrapper', { 'responsive-wrapper': responsive })}>
        <span className="project-title">{title}</span>
    </div>
);

ProjectTitle.propTypes = {
    title: string,
    responsive: bool
};

export default ProjectTitle;
